var ClosestDivision, Geocoder, Location, SearchBar, SearchBarView, base, base1, base2, setTranslations;

SearchBarView = require('./views/search_bar');

Location = require('../../../../../src/frontend/helper/search/helper/m_location_helper');

ClosestDivision = require('../../../../../src/frontend/helper/search/common/m_closest_division');

setTranslations = require('../../../../../src/frontend/helper/search/helper/m_typeahead_helper.coffee').setTranslations;

Geocoder = require('../../../../../src/frontend/helper/search/common/m_geocoder');

module.exports = SearchBar = {
  Autocomplete: {},
  init: function(options) {
    var $searchBar;
    SearchBar.GOOGLE_GEO_URL = options.google_geo_url;
    Location.setDivision(options.division);
    setTranslations(Groupon.LS.translations);
    if (($searchBar = $('form#search-bar, form#ls-search-form')).length) {
      return new SearchBarView({
        $el: $searchBar
      });
    }
  }
};

$(function() {
  var searchConfig;
  if ((searchConfig = Groupon.Modules.SearchBar.Config)) {
    return Groupon.Modules.SearchBar.init(searchConfig);
  }
});

if ((base = window.Groupon).Utils == null) {
  base.Utils = {};
}

_.extend(Groupon.Utils, {
  ClosestDivision: ClosestDivision,
  Geocoder: Geocoder
});

if ((base1 = window.Groupon).Modules == null) {
  base1.Modules = {};
}

if ((base2 = window.Groupon.Modules).SearchBar == null) {
  base2.SearchBar = {};
}

_.extend(window.Groupon.Modules.SearchBar, SearchBar);

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL1VzZXJzL2pwdmVyZGVqby9Hcm91cG9uL3Nscy9tb2R1bGVzL2dpZ19ib2R5L2hlYWRlci9zZWFyY2hfYmFyL2Zyb250ZW5kL2luZGV4LmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi9Vc2Vycy9qcHZlcmRlam8vR3JvdXBvbi9zbHMvbW9kdWxlcy9naWdfYm9keS9oZWFkZXIvc2VhcmNoX2Jhci9mcm9udGVuZC9pbmRleC5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsSUFBQTs7QUFBQSxhQUFBLEdBQWdCLE9BQUEsQ0FBUSxvQkFBUjs7QUFDaEIsUUFBQSxHQUFXLE9BQUEsQ0FBUSxvRUFBUjs7QUFDWCxlQUFBLEdBQWtCLE9BQUEsQ0FBUSxxRUFBUjs7QUFDakIsa0JBQW1CLE9BQUEsQ0FBUSw0RUFBUjs7QUFDcEIsUUFBQSxHQUFXLE9BQUEsQ0FBUSw2REFBUjs7QUFHWCxNQUFNLENBQUMsT0FBUCxHQUFpQixTQUFBLEdBQVk7RUFDM0IsWUFBQSxFQUFjLEVBRGE7RUFHM0IsSUFBQSxFQUFNLFNBQUMsT0FBRDtBQUNKLFFBQUE7SUFBQSxTQUFTLENBQUMsY0FBVixHQUEyQixPQUFPLENBQUM7SUFDbkMsUUFBUSxDQUFDLFdBQVQsQ0FBcUIsT0FBTyxDQUFDLFFBQTdCO0lBQ0EsZUFBQSxDQUFnQixPQUFPLENBQUMsRUFBRSxDQUFDLFlBQTNCO0lBRUEsSUFBRyxDQUFDLFVBQUEsR0FBYSxDQUFBLENBQUUsc0NBQUYsQ0FBZCxDQUF3RCxDQUFDLE1BQTVEO2FBQ00sSUFBQSxhQUFBLENBQWM7UUFDaEIsR0FBQSxFQUFLLFVBRFc7T0FBZCxFQUROOztFQUxJLENBSHFCOzs7QUFjN0IsQ0FBQSxDQUFFLFNBQUE7QUFDQSxNQUFBO0VBQUEsSUFBRyxDQUFDLFlBQUEsR0FBZSxPQUFPLENBQUMsT0FBTyxDQUFDLFNBQVMsQ0FBQyxNQUExQyxDQUFIO1dBQ0UsT0FBTyxDQUFDLE9BQU8sQ0FBQyxTQUFTLENBQUMsSUFBMUIsQ0FBK0IsWUFBL0IsRUFERjs7QUFEQSxDQUFGOzs7TUFJYyxDQUFDLFFBQVM7OztBQUN4QixDQUFDLENBQUMsTUFBRixDQUFTLE9BQU8sQ0FBQyxLQUFqQixFQUF3QjtFQUN0QixpQkFBQSxlQURzQjtFQUV0QixVQUFBLFFBRnNCO0NBQXhCOzs7T0FLYyxDQUFDLFVBQVc7Ozs7T0FDSixDQUFDLFlBQWE7OztBQUNwQyxDQUFDLENBQUMsTUFBRixDQUFTLE1BQU0sQ0FBQyxPQUFPLENBQUMsT0FBTyxDQUFDLFNBQWhDLEVBQTJDLFNBQTNDIn0=
